import { call, put, takeLatest } from "redux-saga/effects";
import { updateSession,getAllSessionsData } from "../http/requests/session";
import { SessionType,setAllSessionsData,setVtrackLoader } from "../redux/actions";
import { toastOptions } from "../common/utils/toasterOptions";
import { toast } from "react-toastify";

function* workerUpdateSessionSaga({ payload }) {
    try {        
        yield put(setVtrackLoader(true));
        yield call(updateSession, payload.data);
        toast.success("Data Saved", toastOptions)
        const sessionDetail = yield call(getAllSessionsData,"");
        yield put(setAllSessionsData(sessionDetail));
        yield put(setVtrackLoader(false));
    } catch (err) {
        toast.error(err.data.errorMessage, toastOptions)
        yield put(setVtrackLoader(false));
    }
}

export function* updateSessionSaga() {
    yield takeLatest(
        SessionType.UPDATE_SESSION,
        workerUpdateSessionSaga
    );
};